import { suggestDomains as suggest } from '@wix/ambassador-premium-domains-v2-suggestion/http'
import { SuggestDomainsRequest } from '@wix/ambassador-premium-domains-v2-suggestion/types'

import { withMonitoring } from '../monitoring/withMonitoring'
import { ambassadorHttpClient } from './httpClient'

export const suggestDomains = async (params: SuggestDomainsRequest) => {
  const request = () => ambassadorHttpClient.request(suggest(params))
  return withMonitoring(request, 'suggestDomains')
}
